import * as SliderPrimitive from "@radix-ui/react-slider";

export const RangeFilter = ({ label, value, min, max, onChange, format = (v) => v, testId }) => (
  <div data-testid={testId}>
    <div className="mb-3 flex items-center justify-between">
      <span className="eyebrow">{label}</span>
      <span data-testid={`${testId}-value`} className="font-data text-xs text-white">
        {format(value[0])} – {format(value[1])}
      </span>
    </div>
    <SliderPrimitive.Root
      className="relative flex h-5 w-full touch-none select-none items-center"
      min={min} max={max} step={1} value={value} onValueChange={onChange} minStepsBetweenThumbs={0}
    >
      <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-slate-800">
        <SliderPrimitive.Range className="absolute h-full bg-[#FF2D78]" />
      </SliderPrimitive.Track>
      {[0, 1].map((i) => (
        <SliderPrimitive.Thumb key={i} aria-label={`${label} ${i ? "max" : "min"}`} data-testid={`${testId}-thumb-${i ? "max" : "min"}`}
          className="block h-4 w-4 rounded-full border-2 border-[#FF2D78] bg-[#0B0F19] transition-transform duration-150 hover:scale-125 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF2D78]/50" />
      ))}
    </SliderPrimitive.Root>
  </div>
);
